export default "__VITE_ASSET__BMkiYucI__"